import { render, staticRenderFns } from "./PatternUserProfile.vue?vue&type=template&id=780f2bf1&"
import script from "./PatternUserProfile.vue?vue&type=script&lang=js&"
export * from "./PatternUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./PatternUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports